"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createStore_1 = __importDefault(require("./createStore"));
const createStore_2 = require("./createStore");
const Note_1 = __importDefault(require("../models/Note"));
const NoteActions_1 = __importDefault(require("../actions/NoteActions"));
const NotesSource_1 = __importDefault(require("../sources/NotesSource"));
class NoteStore extends createStore_2.BaseStore {
    constructor() {
        super(...arguments);
        this.notes = [];
        this.saving = false;
    }
    getActionsHandlers() {
        return {
            receivedNotes: NoteActions_1.default.receivedNotes,
            loadingNotes: NoteActions_1.default.loadingNotes,
            fetchingNotesFailed: NoteActions_1.default.fetchingNotesFailed,
            savedNote: NoteActions_1.default.savedNote,
            savingNote: NoteActions_1.default.savingNote,
            savingNoteFailed: NoteActions_1.default.savingNoteFailed,
        };
    }
    getState() {
        return this;
    }
    getPublicMethods() {
        return {
            getNotes: () => this.notes.map(note => new Note_1.default(note)),
            isSaving: () => this.saving,
        };
    }
    getSource() {
        return NotesSource_1.default;
    }
    receivedNotes(data) {
        this.setState({
            notes: data.map(note => new Note_1.default(note)),
        });
    }
    loadingNotes() { }
    fetchingNotesFailed() { }
    savedNote(noteData) {
        const note = new Note_1.default(noteData);
        const updatedNotes = this.notes.slice();
        const existingIndex = updatedNotes.findIndex(n => n.section_code === note.section_code);
        if (existingIndex !== -1) {
            updatedNotes[existingIndex] = note;
        }
        else {
            updatedNotes.push(note);
        }
        this.setState({
            notes: updatedNotes,
            saving: false,
        });
    }
    savingNote() {
        this.setState({
            saving: true,
        });
    }
    savingNoteFailed() {
        this.setState({
            saving: false,
        });
    }
}
const store = (0, createStore_1.default)(NoteStore, 'NoteStore');
exports.default = store;
